import { LinkButton, UIText2 } from '@cian/ui-kit';
import React from 'react';

import { NBSP } from 'shared/constants';

import styles from './styles.css';

interface IMortgageBrokerBannerProps {
  promoUrl: string;
  calculatorUrl: string;
  onLinkClick: () => void;
}

export const MortgageBrokerBanner: React.FC<IMortgageBrokerBannerProps> = ({
  promoUrl,
  calculatorUrl,
  onLinkClick,
}) => {
  return (
    <aside className={styles['container']}>
      <div className={styles['inner-container']} data-testid="mortgage-broker-main-banner">
        <div className={styles['left-side']}>
          <span className={styles['title']}>Оформите ипотеку для{NBSP}своих клиентов</span>
          <UIText2 color="text-inverted-default">
            Одна заявка в{NBSP}несколько банков, одобрение{NBSP}онлайн
          </UIText2>
          <div className={styles['link-buttons']}>
            <LinkButton
              theme="fill_white_primary"
              size="M"
              href={calculatorUrl}
              onClick={onLinkClick}
              target="_blank"
              rel="noopener noreferrer"
            >
              Оформить ипотеку
            </LinkButton>
            <LinkButton
              theme="fill_white_secondary"
              size="M"
              href={promoUrl}
              onClick={onLinkClick}
              target="_blank"
              rel="noopener noreferrer"
            >
              Подробнее о сервисе
            </LinkButton>
          </div>
        </div>
        <div className={styles['image']}></div>
      </div>
    </aside>
  );
};
